<template>
  <div class="orderList">
    <Header :actived="'orders'"></Header>
    <div class="home">
      <a-affix :offset-top="75">
        <a-alert
          message="Success Tips"
          description="Payment of your order group succeed."
          type="success"
          show-icon
          v-if="successAlertTip"
        />
      </a-affix>
      <Warn></Warn>
      <orderMask v-if="isOrder" :isSamples="isSamples"></orderMask>
      <div class="good">
        <div class="order-btn">
          <a-button
            class="onePayBtn"
            :disabled="selectedRowKeys.length <= 0"
            type="primary"
            @click="goOnePay(0)"
            >Pay With Credit Card</a-button
          >
         <!--<a-button
            class="onePayBtn"
            :disabled="selectedRowKeys.length <= 0"
            type="primary"
            @click="goOnePay(1)"
            >Pay With PayPal</a-button
          >-->
          <a-button type="primary" icon="download" @click="isImport = true"
            >Import order</a-button
          >
          <a-button type="primary" @click="createOrder(false)"
            >Create an order</a-button
          >
          <a-button @click="createOrder(true)">Get samples</a-button>
        </div>
        <a-input-search
          v-model="paginations.keyword"
          placeholder="Search by order number"
          enter-button="Search"
          size="large"
          @search="onSearch"
        />
        <!-- All Orders -->
        <div class="choice clearfix">
          <button
            class="btn"
            :class="{ actived: pageStatu == 0 }"
            @click="changePageStatu(0)"
          >
            All Orders
          </button>
          <button
            class="btn"
            :class="{ actived: pageStatu == 1 }"
            @click="changePageStatu(1)"
          >
            Pending
          </button>
          <button
            class="btn"
            :class="{ actived: pageStatu == 2 }"
            @click="changePageStatu(2)"
          >
            Confirmed
          </button>
          <button
            class="btn"
            :class="{ actived: pageStatu == 3 }"
            @click="changePageStatu(3)"
          >
            In production
          </button>
          <a-dropdown :trigger="['click']">
            <button
              class="btn lue"
              :class="{ actived: pageStatu == 4 }"
            ></button>
            <div class="mask-statu" slot="overlay">
              <p
                class="mask-statu-list"
                v-for="(item, index) in pageStatulist"
                :key="index"
                @click="changePageStatu(item.value)"
              >
                <em>
                  <a-icon type="check" v-if="index == pageStatu" />
                </em>
                <span>{{ item.name }}</span>
              </p>
            </div>
          </a-dropdown>
          <a-range-picker
            style="float:right"
            :format="dateFormat"
            @change="handleOpenChange"
          />
        </div>
        <div class="order-list">
          <div class="order-li clearfix">
            <a-table
              :customRow="rowClick"
              :pagination="paginations"
              rowKey="orderNo"
              :columns="columns"
              :data-source="orderList"
              :row-selection="{
                selectedRowKeys: selectedRowKeys,
                onChange: onSelectChange
              }"
              @change="pageChange"
            >
              <span slot="tag" slot-scope="orderNo, item">
                <p>{{ item.orderNo }}</p>
                <p>
                  <a-tag color="red" v-if="item.isRisk">Danger</a-tag>
                </p>
              </span>
              <span slot="status" slot-scope="status">
                <a-button class="pending" type="primary" v-if="status == 1"
                  >Pending</a-button
                >
                <a-button class="confirmed" type="primary" v-if="status == 2"
                  >Confirmed</a-button
                >
                <a-button class="confirmed" type="primary" v-if="status == 3"
                  >In production</a-button
                >
                <a-button class="fulfilled" type="primary" v-if="status == 4"
                  >Partially fulfilled</a-button
                >
                <a-button class="fulfilled" type="primary" v-if="status == 5"
                  >Fulfilled</a-button
                >
                <a-button class="onhold" type="danger" v-if="status == 6"
                  >On hold</a-button
                >
                <a-button class="onhold" type="primary" v-if="status == 7"
                  >Cancelled</a-button
                >
              </span>
            </a-table>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isOnePay2">
      <onepPay :isShow="isOnePay2" :orderId="payOrder" :payType="3"></onepPay>
    </div>
    <div class="dialog-import" v-if="isImport">
      <div class="warper">
        <a-icon type="close" @click="isImport = false" />
        <a-upload
          class="upload-demo"
          :showUploadList="false"
          :customRequest="importantOrder"
          action
        >
          <a-button type="primary" icon="download" size="large"
            >import table</a-button
          >
        </a-upload>
        <a @click="downloadOrder"> template download</a>
      </div>
    </div>
    <!-- 支付前的确认 -->
    <div class="confirm-dialog" v-show="isOnePay1">
      <div class="c-content">
        <div class="c-head">Bulk Payment</div>
        <div class="c-con">
          <p class="c-title">Do you want to process the bulk payment?</p>
          <p class="c-msg">
            {{ payOrder.length }} order groups have been selected
          </p>
          <p class="c-no">{{ selectedRowKeys.toString() }}</p>
        </div>
        <div class="c-head" style="text-align: right">
          <a-button
            type="primary"
            v-show="isPayPal == false && payOrder.length > 0"
            @click="confirmPay"
            class="onepay"
            style="margin-right: 20px"
            >Confirm</a-button
          >
          <div class="paypal">
            <a-button
              class="pay-btn"
              v-show="isPayPal"
              type="primary"
              :disabled="selectedRowKeys.length <= 0"
              >Confirm</a-button
            >
            <div id="paypal-button-container"></div>
          </div>
          <a-button style="margin-right: 35px" @click="closeDialog"
            >Cancel</a-button
          >
        </div>
        <div class="c-close" @click="closeDialog">
          <a-icon type="close" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header";
import Warn from "@/components/Warn";
import orderMask from "@/components/CreateOrder";
import { orderPage, orderStatistics, ImportOrder } from "@/api/order";
import onepPay from "@/components/onePay";
import { createPaypal, executePaypal } from "@/api/pay";
import { submitOssFile } from "@/api/file";
import OSS from "ali-oss";
import { fileSts } from "@/api/oss";
export default {
  components: {
    Header,
    Warn,
    orderMask,
    onepPay
  },
  data() {
    return {
      rowClick: record => ({
        // 事件
        on: {
          click: () => {
            this.goOrderDdetail(record.id, record.orderNo);
          }
        }
      }),
      pageStatulist: [
        {
          name: "All",
          value: 0,
          isChecked: false
        },
        {
          name: "Pending",
          value: 1,
          isChecked: false
        },
        {
          name: "Confirmed",
          value: 2,
          isChecked: false
        },
        {
          name: "In production",
          value: 3,
          isChecked: false
        },
        {
          name: "Partially fulfilled",
          value: 4,
          isChecked: false
        },
        {
          name: "Fulfilled",
          value: 5,
          isChecked: false
        },
        {
          name: "On hold",
          value: 6,
          isChecked: false
        },
        {
          name: "Cancelled",
          value: 7,
          isChecked: false
        }
      ],
      isImport: false,
      ossData: {},
      payMethod: "",
      paginations: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        keyword: "", //关键字
        status: "",
        startDate: "",
        endDate: ""
      },
      isPayPal: false,
      UnpayTotal: 0, // 未支付的订单数
      pageStatu: 0,
      successAlertTip: false,
      isOnePay1: false, //支付确认弹框
      isOnePay2: false, //一次性付款弹框是否显示
      isSamples: true, //是否样品单
      actived: "Orders",
      isOrder: false, //是否显示创建订单弹窗
      orderList: [],
      selectedRowKeys: [], // Check here to configure the default column
      // addDate  orderNo  isRisk  customerName  totalPrice
      columns: [
        {
          title: "Creating Date",
          dataIndex: "addDate",
          key: "addDate"
        },
        {
          title: "Order No.",
          dataIndex: "orderNo",
          key: "orderNo",
          scopedSlots: { customRender: "tag" }
        },
        {
          title: "Recipient's Name",
          key: "customerName",
          dataIndex: "customerName"
        },
        {
          title: "Total Cost($)",
          key: "totalPrice",
          dataIndex: "totalPrice"
        },
        {
          title: "Status",
          key: "status",
          dataIndex: "status",
          scopedSlots: { customRender: "status" }
        }
      ],
      payOrder: [], //有效的订单号
      dateFormat: "YYYY-MM-DD",
      startDate: "",
      endDate: ""
    };
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    }
  },
  async mounted() {
    if (this.$route.query.isOrder) {
      this.isOrder = this.$route.query.isOrder;
      this.isSamples = this.$route.query.isSamples;
    }
    {
      let { data } = await orderStatistics();
      this.UnpayTotal = data.pendingCount;
    }
    this.getOrderPage();
    this.getOssMsg();
    this.paypalReady();
  },
  methods: {
    downloadOrder() {
      window.open("/import.csv");
      // window.location.href = "../../assets/img/import.csv";
    },
    //获取OSS信息
    async getOssMsg() {
      let { data } = await fileSts();
      this.ossData = data;
    },
    async importantOrder(file) {
      const _this = this;
      Promise.all([_this.submitOSSFile2(file.file)]).then(values => {
        _this.importOrder(values[0]);
      });
    },
    async importOrder(id) {
      let { code, msg } = await ImportOrder({ fileId: id });
      if (code == 200) {
        this.$message.success("success");
      } else {
        this.$message.error(msg);
      }
    },
    async submitOSSFile2(file) {
      try {
        let _this = this;
        // 获取OSS配置信息
        let client = new OSS({
          endpoint: this.ossData.ossEndpoint,
          accessKeyId: this.ossData.accessKeyId,
          accessKeySecret: this.ossData.accessKeySecret,
          bucket: this.ossData.bucket,
          stsToken: this.ossData.securityToken
        });
        const point = file.name.lastIndexOf(".");
        let suffix = file.name.substr(point);
        let fileName = file.name.substr(0, point);
        let date = _this.$moment().format("YYYYMMDDHHmmss");
        let fileNames = `${this.ossData.ossObjectNamePrefix}${fileName}_${date}${suffix}`;
        // 简单上传文件
        const res = await client.multipartUpload(fileNames, file, {
          progress: async function(p) {
            console.log(p);
          }
        });
        if (res.res.statusCode === 200) {
          let imageUrl = res.res.requestUrls[0];
          let { data } = await submitOssFile({
            fileName: fileName,
            fileUrl: imageUrl,
            bucketName: this.ossData.bucket,
            objectName: fileNames,
            fileType: 3
          });
          console.warn(data);
          return data;
        } else {
          this.$message.error("Image upload failed due to unstable network");
        }
      } catch (error) {
        this.$message.error("Image upload failed due to unstable network");
      }
    },
    //时间变化
    handleOpenChange(date, dateString) {
      this.paginations.startDate = dateString[0];
      this.paginations.endDate = dateString[1];
      this.paginations.current = 1;
      this.orderList = [];
      this.getOrderPage();
    },
    pageChange(page) {
      this.orderList = [];
      this.paginations.current = page.current;
      this.paginations.pageSize = page.pageSize;
      this.getOrderPage();
    },
    async getOrderPage() {
      let { data } = await orderPage({
        current: this.paginations.current,
        size: this.paginations.pageSize,
        keyword: this.paginations.keyword.trim(),
        status: this.paginations.status,
        startDate: this.paginations.startDate,
        endDate: this.paginations.endDate
      });
      this.paginations.total = data.total;
      if (data.records) {
        this.orderList.push(...data.records);
      }
    },
    //paypal支付 start
    paypalReady() {
      console.warn("paypal ready");
      const _this = this;
      // eslint-disable-next-line no-undef
      paypal.Button.render(
        {
          env: process.env.VUE_APP_PAY, // sandbox | production
          // Show the buyer a 'Pay Now' button in the checkout flow
          commit: true,
          // payment() is called when the button is clicked
          payment: function() {
            return _this.ceatePayPals();
          },
          //支付完成后
          onAuthorize: function(data, actions) {
            console.log(data, actions);
            var datas = {
              paymentId: data.paymentID, //订单id
              payerId: data.payerID //支付用户id
            };
            return _this.executePaypals(datas);
          }
        },
        "paypal-button-container"
      );
    },
    //查询paypal支付是否成功
    async executePaypals(item) {
      let { code, data } = await executePaypal(item);
      if (code == 200) {
        if (data.status == 1) {
          this.$message.success("Pay success");
          setTimeout(() => {
            location.reload();
          }, 500);
        } else {
          this.$message.success(data.failReason);
        }
      }
    },
    //创建paypal支付
    async ceatePayPals() {
      this.getpayOrder();
      let { data } = await createPaypal({
        cancelUrl:
          process.env.VUE_APP_API_URL + "/unpay?orderId=" + this.payOrder,
        orderIds: this.payOrder,
        returnUrl:
          process.env.VUE_APP_API_URL + "/unpay?orderId=" + this.payOrder
      });
      return data.payId;
    },
    async paymentCompleted(data) {
      // 用户支付完成的回调，可以拿到订单id
      console.log(data);
    },
    paymentCancelled(data) {
      // 用户取消交易的回调
      console.log(data);
    },
    //paypal支付 end
    getCheckboxProps: record => console.log(record),
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    //获取有效的即将要支付的订单编号
    getpayOrder() {
      this.payOrder = [];
      for (let i = 0; i < this.orderList.length; i++) {
        for (let j = 0; j < this.selectedRowKeys.length; j++) {
          if (
            this.orderList[i]["orderNo"] == this.selectedRowKeys[j] &&
            this.orderList[i]["status"] == 1
          ) {
            this.payOrder.push(parseInt(this.orderList[i]["id"]));
            break;
          }
        }
      }
    },
    confirmPay() {
      this.closeDialog();
      this.isOnePay2 = true;
    },
    //去一次性支付
    goOnePay(val) {
      this.getpayOrder();
      this.isOnePay1 = true;
      if (val == 1) {
        this.isPayPal = true;
      } else if (val == 0) {
        this.isPayPal = false;
      }
    },
    //关闭弹出
    closeDialog() {
      this.isOnePay2 = false;
      this.isOnePay1 = false;
      this.isPayPal = false;
    },
    //是否样品
    createOrder(val) {
      this.isOrder = true;
      this.isSamples = val;
    },
    onSearch() {
      this.orderList = [];
      this.paginations.current = 1;
      this.getOrderPage();
    },
    //去订单详情
    goOrderDdetail(id, sn) {
      console.log(id);
      this.$router.push({
        path: "/unpay",
        query: {
          orderId: id,
          orderSn: sn
        }
      });
    },
    changePageStatu(e) {
      this.pageStatu = e;
      this.orderList = [];
      this.paginations.current = 1;
      if (e == 0) {
        this.paginations.status = "";
      } else {
        this.paginations.status = e;
      }
      this.getOrderPage();
    },
    //支付成功提示
    paySuccessTip() {
      const _this = this;
      this.successAlertTip = true;
      setTimeout(() => {
        _this.successAlertTip = false;
      }, 3000);
    }
  }
};
</script>
<style scoped lang="scss">
.dialog-import {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  overflow-y: scroll;
  z-index: 30;
  .warper {
    background: white;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -65px;
    margin-left: -200px;
    width: 290px;
    height: 150px;
    text-align: center;
    padding-top: 45px;
    i {
      position: absolute;
      top: 15px;
      right: 20px;
      font-size: 14px;
      cursor: pointer;
    }
    a {
      display: block;
      margin-top: 20px;
      text-align: center;
    }
  }
}
.pending {
  background-color: #ffca87;
  border: 1px solid #ffca87;
  color: #f34547;
}
.confirmed {
  background-color: #caebfc;
  border: 1px solid #caebfc;
  color: #00acfc;
}
.partially {
  background-color: #d3e8d5;
  border: 1px solid #d3e8d5;
  color: #23992f;
}
.fulfilled {
  background-color: #23992f;
  border: 1px solid #23992f;
  color: white;
}
.onhold {
  background-color: #ffe5c2;
  border: 1px solid #ffe5c2;
  color: #ff6134;
}
.onePayBtn {
  float: left;
  width: 200px;
  font-style: italic;
  border-radius: 2px;
  margin-left: 0;
  margin-right: 10px;
}
.paypal {
  position: relative;
  height: 30px;
  text-align: center;
  margin-left: 13px;
  width: 200px;
  button {
    position: absolute;
    left: 50%;
    margin-left: -100px;
    border-radius: 2px;
    font-style: italic;
    width: 200px;
  }
  #paypal-button-container {
    position: absolute;
    top: 12px;
    height: 30px;
    left: 50%;
    margin-left: -100px;
    width: 200px;
    opacity: 0;
  }
}
.mask-statu {
  position: absolute;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25), 0 1px 4px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  color: #1b1b1b;
  min-width: 217px;
  top: 90%;
  right: 0;
  cursor: default;
  padding: 16px 0;
  p {
    margin: 0;
  }
  .mask-statu-list {
    line-height: 24px;
    padding: 4px 20px 4px 30px;
    text-align: left;
    font-size: 15px;
    color: #383838;
    position: relative;
    cursor: pointer;
    display: flex;
    em {
      width: 30px;
    }
  }
  .mask-statu-list:hover {
    background: #106ebe;
  }
}
.choice {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 20px;
}
.choice .btn {
  display: block;
  padding: 0 16px;
  border-radius: 18px;
  background-color: #f7f7f7;
  color: #1b1b1b;
  line-height: 36px;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 0;
  float: left;
  margin-right: 20px;
  cursor: pointer;
}
.choice .unpay {
  background-color: #d8504a !important;
  color: white !important;
}
.choice .lue {
  width: 36px;
  height: 36px;
  background: url("../../assets/img/nue.png") no-repeat;
  background-size: 100%;
  background-color: #f7f7f7;
}
.choice .btn:hover {
  background-color: #d8d8d8;
}
.choice .btn.actived {
  background-color: #1b1b1b;
  color: white;
}
.confirm-dialog {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
  .c-content {
    width: 35%;
    background: white;
    transform: translate(-50%, -50%);
    position: fixed;
    top: 50%;
    left: 50%;
  }
  .onepay {
    margin-right: 20px;
    position: absolute;
    left: 19px;
    bottom: 9px;
  }
  .paypal {
    position: relative;
    height: 30px;
    text-align: center;
    margin-left: 13px;
    width: 200px;
    display: inline-block;
    margin-right: 15px;
    padding-top: 11px;
  }
  .c-head {
    background-color: #f7f7f7;
    height: 55px;
    line-height: 55px;
    text-align: center;
    font-size: 20px;
  }
  .c-con {
    padding: 0 20px;
    box-sizing: border-box;
  }
  .c-title {
    font-weight: bold;
    margin-top: 20px;
    font-size: 16px;
  }
  .c-msg {
    font-size: 16px;
  }
  .c-no {
    font-size: 16px;
    color: #106ebe;
    word-wrap: break-word;
  }
  .c-close {
    position: absolute;
    top: 16px;
    right: 22px;
    font-size: 19px;
    cursor: pointer;
  }
}
#paypal-button-container {
  margin-left: 24px;
  float: left;
  z-index: 0;
  position: relative;
}
</style>
